module.exports = __webpack_public_path__ + "img/banner.d04e6748.png";